import React from 'react';
import { Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FaArrowDown, FaArrowRight, FaChartLine, FaCheck, FaCloud, FaPaintBrush, FaSyncAlt } from 'react-icons/fa';
import { cloudinaryAsset } from '../config/media';

const asset = (path) => cloudinaryAsset(`/pantallas-soluciones-interactivas/${path}`);

const solutions = [
  { key: 'ledScreens', image: 'tipos/pantalla-led.webp' },
  { key: 'ledTotems', image: 'tipos/totem-led.webp' },
  { key: 'interactiveTotems', image: 'tipos/totem-interactivo.webp' },
  { key: 'mapping', image: 'tipos/video-mapping.webp' }
];

const appFeatures = [
  { key: 'customDesign', icon: FaPaintBrush },
  { key: 'analytics', icon: FaChartLine },
  { key: 'remote', icon: FaSyncAlt },
  { key: 'cloud', icon: FaCloud }
];

const technologyKeys = ['screens', 'multitouch', 'software', 'support'];
const caseImages = Array.from({ length: 5 }, (_, index) => asset(`casos/casos-reales-${index + 1}.webp`));

const PantallasSolucionesInteractivas = () => {
  const { t } = useTranslation();

  return (
    <main id="pantallas-soluciones-interactivas" className="interactive-screens-page">
      <section className="interactive-screens-hero" style={{ backgroundImage: `linear-gradient(90deg, rgba(3, 24, 51, .94) 0%, rgba(7, 54, 109, .72) 52%, rgba(7, 54, 109, .18) 100%), url("${caseImages[0]}")` }}>
        <Container>
          <div className="interactive-screens-hero-copy">
            <p className="interactive-screens-eyebrow">{t('interactiveScreensPage.hero.eyebrow')}</p>
            <h1>{t('interactiveScreensPage.hero.title')}</h1>
            <p>{t('interactiveScreensPage.hero.description')}</p>
            <a href="#tipos-soluciones" className="interactive-screens-primary-action">
              {t('interactiveScreensPage.hero.action')} <FaArrowDown aria-hidden="true" />
            </a>
          </div>
        </Container>
      </section>

      <section id="tipos-soluciones" className="interactive-screens-solutions">
        <Container>
          <div className="interactive-screens-heading">
            <p className="interactive-screens-eyebrow">{t('interactiveScreensPage.solutions.eyebrow')}</p>
            <h2>{t('interactiveScreensPage.solutions.title')}</h2>
            <p>{t('interactiveScreensPage.solutions.description')}</p>
          </div>
          <div className="interactive-screens-solutions-grid">
            {solutions.map(({ key, image }) => (
              <article className="interactive-screen-solution" key={key}>
                <img src={asset(image)} alt={t(`interactiveScreensPage.solutions.items.${key}.title`)} loading="lazy" />
                <div>
                  <h3>{t(`interactiveScreensPage.solutions.items.${key}.title`)}</h3>
                  <p>{t(`interactiveScreensPage.solutions.items.${key}.description`)}</p>
                  {key === 'ledTotems' && <span>{t(`interactiveScreensPage.solutions.items.${key}.details`)}</span>}
                </div>
              </article>
            ))}
          </div>
        </Container>
      </section>

      <section className="interactive-screens-apps">
        <Container>
          <div className="interactive-screens-apps-grid">
            <div className="interactive-screens-apps-copy">
              <p className="interactive-screens-eyebrow">{t('interactiveScreensPage.apps.eyebrow')}</p>
              <h2>{t('interactiveScreensPage.apps.title')}</h2>
              <p className="interactive-screens-apps-intro">{t('interactiveScreensPage.apps.description')}</p>
              <div className="interactive-screens-features">
                {appFeatures.map(({ key, icon: Icon }) => (
                  <article key={key}>
                    <Icon aria-hidden="true" />
                    <div>
                      <h3>{t(`interactiveScreensPage.apps.features.${key}.title`)}</h3>
                      <p>{t(`interactiveScreensPage.apps.features.${key}.description`)}</p>
                    </div>
                  </article>
                ))}
              </div>
              <div className="interactive-screens-technology">
                <h3>{t('interactiveScreensPage.apps.technology.title')}</h3>
                <ul>
                  {technologyKeys.map((key) => <li key={key}><FaCheck aria-hidden="true" /> {t(`interactiveScreensPage.apps.technology.${key}`)}</li>)}
                </ul>
              </div>
            </div>
            <div className="interactive-screens-app-visual">
              <img src={asset('apps/apps-a-medida.webp')} alt={t('interactiveScreensPage.apps.imageAlt')} loading="lazy" />
            </div>
          </div>
        </Container>
      </section>

      <section className="interactive-screens-cases">
        <Container>
          <div className="interactive-screens-heading">
            <p className="interactive-screens-eyebrow">{t('interactiveScreensPage.cases.eyebrow')}</p>
            <h2>{t('interactiveScreensPage.cases.title')}</h2>
            <p>{t('interactiveScreensPage.cases.description')}</p>
          </div>
          <div className="interactive-screens-case-grid">
            {caseImages.map((image, index) => (
              <figure key={image}>
                <img src={image} alt={t('interactiveScreensPage.cases.imageAlt', { number: index + 1 })} loading="lazy" />
              </figure>
            ))}
          </div>
        </Container>
      </section>

      <section className="interactive-screens-cta">
        <Container>
          <div>
            <p className="interactive-screens-eyebrow">{t('interactiveScreensPage.cta.eyebrow')}</p>
            <h2>{t('interactiveScreensPage.cta.title')}</h2>
            <p>{t('interactiveScreensPage.cta.description')}</p>
          </div>
          <Link to="/contacto" className="interactive-screens-cta-action">
            {t('interactiveScreensPage.cta.action')} <FaArrowRight aria-hidden="true" />
          </Link>
        </Container>
      </section>
    </main>
  );
};

export default PantallasSolucionesInteractivas;
